import {createMandatoryContext} from '../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Types.
 */

export interface DataFieldsTableSearchValue {
  publicId: string;
  searchValue: string;
}

export interface DataFieldsTableSearchContextData {
  addSearchData: (resources: ReadonlyArray<DataFieldsTableSearchValue>) => void;
}

/*
 * Context.
 */

export const [DataFieldsTableSearchContext, useDataFieldsTableSearchContext] =
  createMandatoryContext<DataFieldsTableSearchContextData>();
